<div class="d-block mb-3">
  @if (tooltip) {
    <ng-container [ngTemplateOutlet]="labelRef"></ng-container>
    <app-tooltip [placement]="'top'">
      <i class="ms-1 fa-light fa-circle-info info-icon text-black"></i>
      <div class="tooltipContent">
        <div class="tooltip-card">
          <div class="tooltip-card-body">
            {{ tooltip }}
          </div>
        </div>
      </div>
    </app-tooltip>
  } @else {
    <span class="fw-regular" [ngClass]="required && editMode ? 'required' : ''">{{ label }}</span>
    @if (!required && editMode) {
      <span class="form-field-optional text-secondary ms-1">(optional)</span>
    }
  }
  <ng-template #labelRef>
    <span class="fw-regular" [ngClass]="required && editMode ? 'required' : ''">{{ label }}</span>
    @if (!required && editMode) {
      <span class="form-field-optional text-secondary ms-1">(optional)</span>
    }
  </ng-template>
</div>
@if (party || editMode) {
  @if (customAddTemplate) {
    <ng-container [ngTemplateOutlet]="customAddTemplate"></ng-container>
  } @else {
    @if (editMode) {
      <div class="row" [ngClass]="!isEmpty(party?.name) ? 'mb-4' : 'mb-0'">
        <div class="col">
          <app-search [required]="required" [(ngModel)]="addressBook" [searchFunction]="findParties"
                      [resultFormatter]="utils.addressBookFormatter" [inputFormatter]="utils.addressBookFormatter"
                      (ngModelChange)="onPartyChange($event)" placement="Select a party from your address book"
                      [newValueFromInputFunction]="newParty" [appAutoFocus]="addressBook && addressBook['isNewRecord']"
                      [newValueFromInputText]="'Create new ' + label.toLowerCase()" [alwaysShowNewValue]="true">
          </app-search>
        </div>
        @if (deletionAllowed) {
          <div class="col-auto">
            <button type="button" class="btn btn-plain btn-outline-danger border-0 p-1 h-100" (click)="deleteParty()"
                    style="box-shadow: none !important; width: 40px">
              <i class="fa fa-fw fa-light fa-trash-can"></i>
            </button>
          </div>
        }
      </div>
    }
  }
  @if (!isEmpty(party?.name)) {
    <div class="card form-group">
      <div class="card-body p-4">
        <div class="row gy-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Name" [includeMargin]="false" [(value)]="party.name"
                            [editMode]="editMode && partyEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="party.name" [required]="editAllowed"/>
            </app-form-field>
          </div>
          @if (showTypeOfPerson) {
            <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
              <app-form-field label="Type of person" [includeMargin]="false" [(value)]="party.typeOfPerson"
                              [editMode]="editMode && partyEditMode"
                              [formatter]="portVisitUtils.enumFormatter"
                              [checkForErrors]="true">
                <app-search [(ngModel)]="party.typeOfPerson" [options]="utils.typeOfPartyPersons"
                            [inputFormatter]="portVisitUtils.enumFormatter" [required]="editAllowed"></app-search>
              </app-form-field>
            </div>
          }
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="EORI number" [includeMargin]="false" [(value)]="party.identificationNumber"
                            [editMode]="editMode && partyEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="party.identificationNumber"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Street" [includeMargin]="false" [(value)]="party.address.street"
                            [editMode]="editMode && partyEditMode" [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="party.address.street"
                     [required]="streetRequired && editAllowed"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Number" [includeMargin]="false" [(value)]="party.address.number"
                            [editMode]="editMode && partyEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="party.address.number"
                     [required]="streetRequired && editAllowed"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Post office box" [includeMargin]="false" [(value)]="party.address.poBox"
                            [editMode]="editMode && partyEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="party.address.poBox"
                     [required]="poBoxRequired && editAllowed"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="City" [includeMargin]="false" [(value)]="party.address.city"
                            [editMode]="editMode && partyEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="party.address.city"
                     [required]="editAllowed"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Postal code" [includeMargin]="false" [(value)]="party.address.postCode"
                            [editMode]="editMode && partyEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="party.address.postCode"
                     [required]="postCodeRequired && editAllowed"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Region" [includeMargin]="false" [(value)]="party.address.subDivision"
                            [editMode]="editMode && partyEditMode"
                            [checkForErrors]="true">
              <input class="input-group rounded form-control" [(ngModel)]="party.address.subDivision"/>
            </app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-country-field [(countryCode)]="party.address.country" [editMode]="editMode && partyEditMode"
                               [includeMargin]="false" (countryCodeChange)="onCountryChange($event)"
                               [required]="editAllowed"></app-country-field>
          </div>
          @if (showCommunications) {
            <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
              <app-form-field label="Telephone" [includeMargin]="false" [(value)]="telephone.identifier"
                              [editMode]="editMode && partyEditMode"
                              [tooltipTemplateRef]="telephoneTooltip" [checkForErrors]="true">
                <input class="input-group rounded form-control" [(ngModel)]="telephone.identifier"
                       [required]="communicationRequired && !email.identifier && editAllowed"
                       [pattern]="rules.telephoneRegexForFilingType(filingType)"
                       [title]="isTsdFiling ? 'for example +31101234567' : 'for example +31 10 123 4567'"/>
              </app-form-field>
            </div>
          }
          @if (showCommunications) {
            <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
              <app-form-field label="Email address" [includeMargin]="false" [(value)]="email.identifier"
                              [editMode]="editMode && partyEditMode"
                              [checkForErrors]="true">
                <input class="input-group rounded form-control" [(ngModel)]="email.identifier"
                       [required]="communicationRequired && !telephone.identifier && editAllowed"/>
              </app-form-field>
            </div>
          }
        </div>
        @if (editMode && partyEditMode && addressBook) {
          <div class="row mt-3">
            <div class="col d-flex align-items-center">
              <div class="form-check form-check-inline m-0 p-0">
                <input [(ngModel)]="addressBook['saveInAddressBook']" class="always-enabled form-check-input m-0"
                       type="checkbox"
                       [id]="'save'+label+'ToAddressBook'">
                <label [for]="'save'+label+'ToAddressBook'">Save {{ label?.toLowerCase() || 'party' }} to address
                  book</label>
              </div>
            </div>
            <div class="col-auto ms-auto">
              <button type="button" class="btn btn-outline-secondary" aria-label="Cancel" (click)="cancel()">Cancel
              </button>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-primary" (click)="save()">Save</button>
            </div>
          </div>
        }
        <div class="position-absolute end-0 top-0 me-2 mt-2">
          @if (editAllowed && editMode && !partyEditMode) {
            <button type="button" class="btn btn-tertiary p-2 px-3 fw-normal"
                    (click)="toggleEditMode()">
              <i class="fa fa-fw fa-light fa-pencil"></i>
              Edit
            </button>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <span class="d-block mb-3 text-muted">Unknown</span>
}
<ng-template #telephoneTooltip>
  <div class="text-start">
    <h6>Telephone Number</h6>
    @if (isTsdFiling) {
      <p>The number should contain digits only, optionally starting with +, without spaces. For example: +31101234567 or 31101234567</p>
    } @else {
      <p>The number should have format: +31101234567</p>
    }
  </div>
</ng-template>
